module.exports = __webpack_public_path__ + "img/4.01a59fda.png";